// extracted by mini-css-extract-plugin
export default {"root":"authLayout_root__tSRU8","content":"authLayout_content__Wmchl"};